import useOrgName from './useOrgName';
import { useGetLocalizedString } from './useGetLocalizedString';
export var useReturnButtonText = function () {
    var orgName = useOrgName();
    var getLocalizedString = useGetLocalizedString();
    return getLocalizedString('RETURN_TO_BANKAPP', [orgName]);
};
